import APIClient from '@/shared/http/clients/api'

const resourceName = 'ajuizamento-simulacao'
const APICore = process.env.APIBaseURLCore

const GetByCardVinculado = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/card/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const AjuizamentoSimulacaoRepository = {
  GetByCardVinculado,
  Create,
  Delete
}

export default AjuizamentoSimulacaoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/ajuizamentoSimulacao.js